import { AfterViewInit, Component, Inject, OnDestroy, ViewChild, Pipe } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subject, startWith, switchMap, catchError, of, map, takeUntil } from 'rxjs';
import { RTL } from 'src/app/@theme/const';
import { ThemeLayoutService } from 'src/app/@theme/services/theme-layout.service';
import { PopUpSearchComponent } from 'src/app/tabms/components/global/pop-up-search/pop-up-search.component';
import { ApiGridInfo } from 'src/app/tabms/models/base/base';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { SessionWrapperService } from 'src/app/tabms/services/session/session-wrapper.service';

@Component({
  selector: 'app-pop-up-search-without-sql',
  templateUrl: './pop-up-search-without-sql.component.html',
  styleUrl: './pop-up-search-without-sql.component.scss'
})
export class PopUpSearchWithoutSqlComponent implements AfterViewInit, OnDestroy {
  dataSource
  displayedColumns: string[] = []
  totalcount
  serviceInstance
  currentLang
  tableData: any[] = []
  params
  menuKey: string
  pageParameters: string
  gridInfoData: ApiGridInfo[] = []
  fieldDisplayOn: number

  private destroy$: Subject<void> = new Subject<void>();

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private baseService: BaseService,
    private themeLayoutService: ThemeLayoutService,
    private dialogRef: MatDialogRef<PopUpSearchComponent>,
  ) {

    this.currentLang = this.baseService.getCurrentLanguage();

    this.dataSource = new MatTableDataSource<any[]>();

    this.serviceInstance = this.data.service
    this.params = this.data.params
    this.menuKey = this.data.menuKey
    this.pageParameters = this.data.pageParameters
    this.fieldDisplayOn = this.data.fieldDisplayOn || 1

    console.log('params', this.params)
    this.setDisplayedColumns();

    this.themeLayoutService.directionChange.subscribe({
      next: (dir) => {
        (dir === RTL) ? (this.currentLang = 'ar') : (this.currentLang = 'en');
      }
    })

  }

  ngAfterViewInit() {
// Disable client-side pagination to maintain server-side pagination
    this.dataSource.paginator = null;
    
    this.getDialogData();
  }

  getDialogData$(pageIndex: number, pageSize: number) {
    return this.serviceInstance.gridList(this.menuKey, this.pageParameters, this.fieldDisplayOn, pageIndex, pageSize, this.params)
  }

  getDialogData() {
    this.paginator.page.pipe(startWith({}), switchMap(() => {
      return this.getDialogData$(this.paginator.pageIndex, this.paginator.pageSize).pipe(catchError(() => of(null)));
    }), map((res: any) => {
      if (res == null) return [];
      this.totalcount = res.result.totalcount;
      this.tableData = res.result.items
      return this.tableData;
    }), takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.tableData = res
        // console.log('gridData', this.gridData)
        this.totalcount = this.totalcount;

        // Update data source with new data
        this.dataSource.data = this.tableData;


        console.log('this.dataSource', this.dataSource)
      }

    })
  }

  setDisplayedColumns(): void {
    this.getDialogData$(0, 1).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.gridInfoData = res.result.headers;
        this.gridInfoData.push({ fieldname: 'action', displaylatname: 'action', displayaraname: 'الإجراءات', fieldtype: 'action' })
        if (this.data.displayedColumns) {
          this.displayedColumns = this.data.displayedColumns
        }
        else {
          this.displayedColumns = this.gridInfoData.map((item) => item.fieldname);
        }

        if(!this.displayedColumns.includes('action')) {
          this.displayedColumns.push('action');
        }
      }
    })
  }

  //select item
  selectedItem(row: any) {
    // console.log(row)
    // const selectedRow = row._entitydto ? row._entitydto : row;
     const selectedRow = row;
    // console.log('selectedItem', selectedRow)
    this.dialogRef.close(selectedRow);
  }

  //region destory subscribtion
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  //end region
}
